import EntitiesList from 'components/entities/EntitiesList';
import { connect } from 'react-redux'
import { Card } from "semantic-ui-react";
import { destroyEntity } from "../../actions/entities";
import { createEntityWithDefaults } from "../../actions/entities";
import { getConsultationReminders } from "../../selectors/consultation_reminders";
import { getCurrentOffice } from "../../selectors/offices";
import ConsultationReminderForm from "./ConsultationReminderForm";
import ConsultationRemindersListItem from "./ConsultationRemindersListItem";

const mapStateToProps = (state, ownProps) => {
  return {
    entities: getConsultationReminders(state),
    entityName: 'consultationReminder',
    item: ConsultationRemindersListItem,
    form: ConsultationReminderForm,
    listComponent: Card.Group,
    loading: state.meta?.consultationReminder?.loading,
    error: state.meta?.consultationReminder?.error
  };
}

const mapDispatchToProps = (dispatch) => {
  return {
    createEntityWithDefaults: () => {
      const office = dispatch( (dispatch, getState) => { return getCurrentOffice(getState())})
      const templateBody = I18n.t('api.consultation_reminders.default_reminder_template', {office: office.name})
      const subject =  I18n.t('api.consultation_reminders.default_reminder_subject')

      let templateId = dispatch(createEntityWithDefaults('emailTemplate', {emailType: 'consultation_reminder', subject: subject, body: templateBody}))
      return  dispatch(createEntityWithDefaults('consultationReminder', { emailTemplateId: templateId }))
    },
    destroyEntity: (reminder) => {
      dispatch(destroyEntity('consultationReminder', reminder.id))
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(EntitiesList)
